
export default function SolutionsSection() {
  const solutions = [
    {
      title: "Humanoid Robots",
      description: "Advanced humanoids designed for repetitive and unsafe tasks with quick training capabilities and comprehensive safety sensors.",
      features: ["Repetitive task automation", "Quick training protocols", "Advanced safety sensors", "Human-robot collaboration"],
      image: "https://public.readdy.ai/ai/img_res/8e82c0879ea0d48185e43d8dc44ac2dd.jpg"
    },
    {
      title: "Robotic Forklifts (AMR/AGF)",
      description: "Autonomous pallet handling systems with intelligent fleet management for seamless warehouse operations.",
      features: ["Autonomous pallet handling", "Fleet management system", "Obstacle avoidance", "Real-time tracking"],
      image: "https://readdy.ai/api/search-image?query=Autonomous%20robotic%20forklift%20moving%20pallets%20in%20warehouse%2C%20modern%20logistics%20facility%2C%20clean%20industrial%20setting%2C%20safety%20markings%20on%20floor%2C%20efficient%20material%20handling%2C%20blue%20and%20white%20industrial%20theme&width=400&height=300&seq=forklift-001&orientation=landscape"
    },
    {
      title: "Safety & Deployment Services",
      description: "Comprehensive site surveys, pilot programs, scaling solutions, training, and ongoing maintenance support.",
      features: ["Site survey & assessment", "Pilot to scale programs", "Comprehensive training", "Ongoing maintenance"],
      image: "https://readdy.ai/api/search-image?query=Industrial%20safety%20engineer%20conducting%20site%20survey%20with%20tablet%2C%20safety%20equipment%20and%20robots%20in%20background%2C%20professional%20service%20environment%2C%20modern%20industrial%20facility%2C%20safety-first%20approach&width=400&height=300&seq=services-001&orientation=landscape"
    }
  ];

  return (
    <section id="solutions" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Products & Solutions</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive robotics solutions designed for real-world industrial applications, 
            backed by proven deployment expertise.
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {solutions.map((solution, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="h-48 bg-gray-100">
                <img 
                  src={solution.image} 
                  alt={solution.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">{solution.title}</h3>
                <p className="text-gray-600 mb-4 leading-relaxed">{solution.description}</p>
                <ul className="space-y-2">
                  {solution.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-sm text-gray-700">
                      <i className="ri-check-line text-blue-600 mr-2 w-4 h-4 flex items-center justify-center"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
